module.exports = __webpack_public_path__ + "static/Juiceland_pin-bf3df6f940cab2764188b677dd294325.png";